<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M10 13H3a1 1 0 00-1 1v7a1 1 0 001 1h7a1 1 0 001-1v-7a1 1 0 00-1-1zm-1 7H4v-5h5zM21 14h-7a1 1 0 000 2h7a1 1 0 000-2zM21 19h-7a1 1 0 000 2h7a1 1 0 000-2zM10 2H3a1 1 0 00-1 1v7a1 1 0 001 1h7a1 1 0 001-1V3a1 1 0 00-1-1zM9 9H4V4h5zM14 5h7a1 1 0 000-2h-7a1 1 0 000 2zM21 8h-7a1 1 0 000 2h7a1 1 0 000-2z"/></svg>